<template>
	<div class="layout__item u-1/1" :class="extraCssClass">
		<h4 class="c-filter-section__sub-heading mb--">
			{{ title }}
			<info-text :info-text="infoText"></info-text>
		</h4>

		<div class="u-1/1" v-for="v in filterValues" :key="v.Value">
			<input
				type="radio"
				:value="v.Value"
				:name="inputsName"
				class="c-inputfields__input--radio"
				@change="updateValues"
				:id="inputsName + v.Value"
				v-model="selectedValue"
			/>

			<label :for="inputsName + v.Value" class="c-inputfields__label">{{ v.Text }}</label>
		</div>
	</div>
</template>

<script>
import { eventHub } from '@/services/eventhub';
import InfoText from '@/partials/InfoText';
export default {
	components: { InfoText },
	props: {
		filterValues: Array,
		title: String,
		infoText: String,
		filterKey: String,
		extraCssClass: String,
	},
	data() {
		return {
			showTooltip: false,
			selectedValue: '',
			inputsName: '',
		};
	},
	watch: {
		filterValues: function () {
			if (!this.filterValues) {
				console.log('No filtervalues present');
				return;
			}
			let selectedItems = this.filterValues.find((f) => f.IsSelected);
			if (!selectedItems) {
				return;
			}
			this.selectedValue = this.filterValues.find((f) => f.IsSelected).Value;
		},
	},
	created() {
		this.inputsName = this.title.toLowerCase().replace(/ /g, '_');
		eventHub.$on('removingFilterValue', (eventData) => {
			if (this.filterKey && eventData.filterKey === this.filterKey) {
				this.selectedValue = null;
				this.updateValues();
			}
		});
	},
	methods: {
		updateValues() {
			this.$emit('valuechange', this.selectedValue);
		},
	},
};
</script>

<style></style>
